import gql from 'graphql-tag'
import styled from 'styled-components'
import { ChoiceQuestion_ExamSurveyAnswerFragment } from 'generated/graphql'
import LevelRatingQuestionLabelLayout from '../LevelRatingQuestionLabelLayout.mobile'
import ChoiceAnswerItemMobile from './ChoiceAnswerItem.mobile'

gql`
  fragment ChoiceQuestion_examSurveyAnswer on ExamSurveyAnswer {
    seq
    content
    id
  }
`

interface ChoiceQuestionMobileProps {
  questioonLabel: string
  questionSeq: number
  questionId: string
  answerList: ChoiceQuestion_ExamSurveyAnswerFragment[]
}

const ChoiceQuestionMobile = ({
  questioonLabel,
  questionSeq,
  questionId,
  answerList,
}: ChoiceQuestionMobileProps) => {
  return (
    <StyledWrapper>
      <LevelRatingQuestionLabelLayout label={questioonLabel}>
        <div className="answer-list-box">
          {answerList.map((answer, index) => {
            return (
              <ChoiceAnswerItemMobile
                label={answer.content}
                key={`${answer.id}-${index}`}
                id={answer.id}
                questionId={questionId}
                questionSeq={questionSeq}
              />
            )
          })}
        </div>
      </LevelRatingQuestionLabelLayout>
    </StyledWrapper>
  )
}

export default ChoiceQuestionMobile

const StyledWrapper = styled.div`
  margin-bottom: 44px;

  .answer-list-box {
    display: flex;
    align-items: center;
    row-gap: 12px;
    flex-wrap: wrap;
  }
`
